/** Track the unoccluded height across both visual-viewport and WebView resizes. */
export class KeyboardState {
  private baseline: number;
  private width: number;
  open = false;
  private awaitingKeyboard = false;

  constructor(height: number, width: number) {
    this.baseline = height;
    this.width = width;
  }

  update(height: number, width: number, editable: boolean, touch: boolean, focus = false): boolean {
    // Rotation/window resizing must not leave the old portrait baseline behind.
    if (Math.abs(width - this.width) > 80) {
      this.baseline = height;
      this.width = width;
      this.awaitingKeyboard = false;
      this.open = editable && touch;
      return this.open;
    }
    const reduced = this.baseline - height > 120;
    if (focus && editable && touch && !this.open) this.awaitingKeyboard = true;
    if (reduced || !editable) this.awaitingKeyboard = false;
    this.open = (reduced && (editable || this.open)) || (this.awaitingKeyboard && editable);
    if (!this.open && !editable) this.baseline = height;
    return this.open;
  }
}
